import type { FilterConfigGroupItem } from '../FilterConfigTypes';

export const throtleMenuGroupList: Array<FilterConfigGroupItem> = [
  {
    groupLabel: 'Audience Demographics',
    ordinalPosition: 1,
    tooltip: 'Audience Demographics',
    filtersInGroup: [
      { name: 'age_range', index: 1 },
      { name: 'education_level', index: 2 },
      { name: 'gender', index: 3 },
      { name: 'household_credit_range', index: 4 },
      { name: 'generations_in_household', index: 5 },
      { name: 'language', index: 6 },
      { name: 'marital_status', index: 7 },
      { name: 'membership_warehouse', index: 8 },
      { name: 'motor_cycle', index: 9 },
      { name: 'num_credit_lines', index: 10 },
      { name: 'num_in_household', index: 11 },
      { name: 'num_of_adults', index: 12 },
      { name: 'num_of_children', index: 13 },
      { name: 'occupation', index: 14 },
      { name: 'occupation_code', index: 15 },
      { name: 'own_swimming_pool', index: 16 },
      { name: 'pets', index: 17 },
      { name: 'pets_own_at_least_one_cat', index: 18 },
      { name: 'pets_own_at_least_one_dog', index: 19 },
      { name: 'politicals', index: 20 },
      { name: 'soho_business', index: 21 },
      { name: 'truck_owner', index: 22 },
      { name: 'valuehunter', index: 23 },
      { name: 'veteran_in_household', index: 24 },
      { name: 'voter_indicator', index: 25 },
      { name: 'zip', index: 26 },
      { name: 'city', index: 27 },
      { name: 'county', index: 28 },
      { name: 'state_code', index: 29 },
      { name: 'mortgageamountinthousands', index: 30 },
      { name: 'mortgageloantype', index: 31 },
      { name: 'refinanceamountinthousands', index: 32 },
      { name: 'refinanceloantype', index: 33 },
      { name: 'new_credit_range', index: 34 },
      { name: 'rv_own', index: 35 },
    ],
  },
  {
    groupLabel: 'Interests and Hobbies',
    ordinalPosition: 3,
    tooltip: 'Interests and Hobbies',
    filtersInGroup: [
      { name: 'auto_work', index: 1 },
      { name: 'baseball', index: 2 },
      { name: 'basketball', index: 3 },
      { name: 'boating_or_sailing', index: 4 },
      { name: 'bookbuyer', index: 5 },
      { name: 'camping_or_hiking', index: 6 },
      { name: 'cars', index: 7 },
      { name: 'casino_gambling', index: 8 },
      { name: 'children_interests', index: 9 },
      { name: 'collector_of_some_kind', index: 10 },
      { name: 'consumer_electronics', index: 11 },
      { name: 'cooking_gourmet', index: 12 },
      { name: 'crafts', index: 13 },
      { name: 'current_affairs_politics', index: 14 },
      { name: 'diet_weight_loss', index: 15 },
      { name: 'entertainment', index: 16 },
      { name: 'family_activites', index: 17 },
      { name: 'fishing', index: 18 },
      { name: 'fitness', index: 19 },
      { name: 'food', index: 20 },
      { name: 'football', index: 21 },
      { name: 'gardening', index: 22 },
      { name: 'general_hobbyist', index: 23 },
      { name: 'golf', index: 24 },
      { name: 'hightechleader', index: 25 },
      { name: 'hockey', index: 26 },
      { name: 'home_improvement', index: 27 },
      { name: 'hunting', index: 28 },
      { name: 'knitting_or_needlework', index: 29 },
      { name: 'movie', index: 30 },
      { name: 'music', index: 31 },
      { name: 'nascar', index: 32 },
      { name: 'photography_and_videography', index: 33 },
      { name: 'running', index: 34 },
      { name: 'snow_skiing', index: 35 },
      { name: 'sports', index: 36 },
      { name: 'sweepstakes_contest', index: 37 },
      { name: 'tennis', index: 38 },
      { name: 'two_or_more_lifestyles', index: 39 },
      { name: 'wine_appreciation', index: 40 },
      { name: 'woodworking', index: 41 },
    ],
  },
  {
    groupLabel: 'Credit Card Ownership',
    ordinalPosition: 5,
    tooltip: null,
    filtersInGroup: [
      { name: 'premium_american_express', index: 1 },
      { name: 'premium_discover', index: 2 },
      { name: 'premium_store_or_retail', index: 3 },
      { name: 'premium_visa_or_mastercard', index: 4 },
      { name: 'regular_american_express', index: 5 },
      { name: 'regular_discover', index: 6 },
      { name: 'regular_visa_or_mastercard', index: 7 },
    ],
  },
  {
    groupLabel: 'Children',
    ordinalPosition: 4,
    tooltip: null,
    filtersInGroup: [
      { name: 'child0_2', index: 1 },
      { name: 'child3_5', index: 2 },
      { name: 'child6_10', index: 3 },
      { name: 'child11_15', index: 4 },
      { name: 'child16_17', index: 5 },
      { name: 'children', index: 6 },
    ],
  },
  {
    groupLabel: 'Charitable Causes',
    ordinalPosition: 2,
    tooltip: null,
    filtersInGroup: [
      { name: 'animal', index: 1 },
      { name: 'childrens', index: 2 },
      { name: 'environment', index: 3 },
      { name: 'general_contributor', index: 4 },
      { name: 'health', index: 5 },
      { name: 'political', index: 6 },
      { name: 'political_conservative', index: 7 },
      { name: 'political_liberal', index: 8 },
      { name: 'religious', index: 9 },
      { name: 'veterans', index: 10 },
    ],
  },
  {
    groupLabel: 'Purchasing Behavior',
    ordinalPosition: 6,
    tooltip: null,
    filtersInGroup: [
      { name: 'crafts_hobby_merchandise', index: 1 },
      { name: 'health_beauty', index: 2 },
      { name: 'internet_buyer', index: 3 },
      { name: 'magazines_purchased', index: 4 },
      { name: 'mail_order_buyer', index: 5 },
    ],
  },
  {
    groupLabel: 'Music Genre Interests',
    ordinalPosition: 7,
    tooltip: null,
    filtersInGroup: [
      { name: 'christian_or_gospel', index: 1 },
      { name: 'classical', index: 2 },
      { name: 'country', index: 3 },
      { name: 'jazz', index: 4 },
      { name: 'rhythm_and_blues', index: 5 },
      { name: 'rock_n_roll', index: 6 },
      { name: 'soft_rock_or_easy_listen', index: 7 },
    ],
  },
  {
    groupLabel: 'Residential Attributes',
    ordinalPosition: 8,
    tooltip: null,
    filtersInGroup: [
      { name: 'home_ownership', index: 1 },
      { name: 'home_price', index: 2 },
      { name: 'home_value', index: 3 },
      { name: 'home_loan_to_value_ratio', index: 4 },
      { name: 'length_of_residence', index: 5 },
      { name: 'inferred_household_rank_of_individual', index: 6 },
      { name: 'year_structure', index: 7 },
    ],
  },
  {
    groupLabel: 'Wealth',
    ordinalPosition: 9,
    tooltip: null,
    filtersInGroup: [
      { name: 'income', index: 1 },
      { name: 'net_worth', index: 2 },
      { name: 'owns_investments', index: 3 },
      { name: 'owns_mutual_funds_cds', index: 4 },
      { name: 'owns_stocks_or_bonds', index: 5 },
    ],
  },
  {
    groupLabel: 'Reading Interests',
    ordinalPosition: 10,
    tooltip: null,
    filtersInGroup: [
      { name: 'reading_best_selling_fiction', index: 1 },
      { name: 'reading_children_s', index: 2 },
      { name: 'reading_computer', index: 3 },
      { name: 'reading_cooking_or_culinary', index: 4 },
      { name: 'reading_country_lifestyle', index: 5 },
      { name: 'reading_fashion', index: 6 },
      { name: 'reading_history', index: 7 },
      { name: 'reading_interior_decorating', index: 8 },
      { name: 'reading_medical_or_health', index: 9 },
      { name: 'reading_military', index: 10 },
      { name: 'reading_mystery', index: 11 },
      { name: 'reading_natural_health_remedies', index: 12 },
      { name: 'reading_news_finance', index: 13 },
      { name: 'reading_people_or_entertainment', index: 14 },
      { name: 'reading_romance', index: 15 },
      { name: 'reading_science_fiction', index: 16 },
      { name: 'reading_science_or_technology', index: 17 },
      { name: 'reading_sports', index: 18 },
      { name: 'reading_world_news_or_politics', index: 19 },
      { name: 'religious_inspirational', index: 20 },
    ],
  },
  {
    groupLabel: 'Travel Preferences',
    ordinalPosition: 11,
    tooltip: null,
    filtersInGroup: [
      { name: 'travel', index: 1 },
      { name: 'travel_business', index: 2 },
      { name: 'travel_cruises', index: 3 },
      { name: 'travel_international', index: 4 },
      { name: 'travel_vacation', index: 5 },
    ],
  },
  {
    groupLabel: 'Contextual',
    ordinalPosition: 12,
    filtersInGroup: [
      { name: 'iab_subgroup', index: 1 },
      { name: 'mesh_subgroup', index: 4 },
    ],
    advancedGroup: false,
  },
];
